import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_98: FaireProductEntity = {
  token: "starter_collection_98",
  type: "product",
  name: "Cosmo Cordial Coupe (Set of 4)",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    '"https://cdn.faire.com/fastly/9429cab18b321ef9086774dc02b25b00c1b58303a7263b8f6c7f8d9132aa6601.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2398',
  priceDollars: 85,
  msrpDollars: 170,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
